import { useEffect, useState, useCallback, useRef } from "react";
import { Box, Typography, IconButton, Dialog, DialogTitle, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { MessagesList } from "./MessagesList";
import { EventCard } from "./EventCard";
import { useLazyGetNotificationsCountQuery, useLazyGetNotificationsQuery } from "../../../middleware/notificationApi";
import { useGetMessageStatusesPostMutation } from "../../../middleware/messageCodeApi";
import { useAppSelector } from "../../../hooks/redux";

export const PushEvent = ({
  open,
  setOpen,
  stopSoundInterval,
  startSoundInterval,
  setNotificationsCount,
  setPrevNotificationsCount,
}) => {
  const intervalRef = useRef(null);
  const popupOpenTimeRef = useRef(null); // Храним время открытия попапа
  const [notifications, setNotifications] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [refetchAfterAccept, setrefetchAfterAccept] = useState(false);

  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [unseenCount, setUnseenCount] = useState(0);
  const [firstRender, setfirstRender] = useState(true);
  const { roleId } = useAppSelector((state) => state.users.info);

  const [getNotifications] = useLazyGetNotificationsQuery();
  const [getNotificationCount] = useLazyGetNotificationsCountQuery();
  const [getMessageStatusesPost] = useGetMessageStatusesPostMutation();

  const intervalNotifCount = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(async () => {
      try {
        const { data } = await getNotificationCount({
          notificationTypes: [9],
        });

        // Обновляем счетчик только если он изменился
        if (data !== undefined && data !== unseenCount) {
          setUnseenCount(data);
        }
      } catch (error) {
        console.error("Ошибка при получении количества уведомлений:", error);
      }
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [unseenCount]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (notifications.length > 0) {
  //       getMessageStatusesPost(notifications.map((notification) => notification.messageId)).then((response) => {
  //         if (response.error) {
  //           return;
  //         }

  //       });
  //     }
  //   }, 1000);

  //   return () => clearInterval(intervalId);
  // }, [notifications]);

  useEffect(() => {
    if (open) {
      // Запоминаем время открытия попапа
      popupOpenTimeRef.current = new Date();
      intervalNotifCount();
    } else {
      // Сбрасываем при закрытии
      popupOpenTimeRef.current = null;
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [open, intervalNotifCount]);

  const fetchData = useCallback(
    async (page = 0, prepend = false) => {
      setIsLoading(true);
      try {
        const response = await getNotifications({
          pageNumber: page,
          notificationTypes: [9],
        });
        const newData = response?.data.data || [];

        if (prepend) {
          setNotifications((prev) => [newData[0], ...prev]);
        } else if (page === 0) {
          setNotifications(newData);
        } else {
          setNotifications((prev) => [...prev, ...newData]);
        }

        setHasMore(newData.length > 0);
      } catch (error) {
        console.error("Ошибка загрузки уведомлений:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [getNotifications]
  );

  useEffect(() => {
    if ((notifications?.length > 0 && !selectedItem && firstRender) || refetchAfterAccept) {
      setSelectedItem(notifications[0]?.messageId);
      setfirstRender(false);
      setrefetchAfterAccept(false);
    }
  }, [notifications, refetchAfterAccept]);

  // Обработчик подгрузки данных при скролле
  const handleLoadMore = useCallback(() => {
    if (!isLoading && hasMore) {
      fetchData(pageNumber + 1);
      setPageNumber(pageNumber + 1);
    }
  }, [isLoading, hasMore, pageNumber]);

  // Проверка новых уведомлений
  useEffect(() => {
    if (unseenCount > 0) {
      if (roleId !== 1) startSoundInterval();
      // Загружаем новые уведомления только если попап открыт
      fetchData(0);
    } else {
      if (roleId !== 1) stopSoundInterval();
    }
    setPrevNotificationsCount(unseenCount);
    setNotificationsCount(unseenCount);
  }, [unseenCount]);

  // Первая загрузка при открытии
  useEffect(() => {
    if (open) {
      fetchData(0);
    }
  }, [open]);

  const onClose = () => {
    setOpen(false);
    setUnseenCount(0);
  };

  return (
    <Dialog open={open} className="modal select_columns" maxWidth="lg" onClose={onClose}>
      <DialogTitle className="dialogheader">
        <Typography className="dialogheaderText">
          {"Сообщения о срабатывании за смену"}
          {unseenCount > 0 && ` (${(unseenCount > 99 ? "99+" : unseenCount)} новых)`}
        </Typography>
        <IconButton className="close_icon" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="dialogcontent">
        <Box className="list-wrapper">
          {notifications.length > 0 ? (
            <>
              <MessagesList
                notifications={notifications}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                onLoadMore={handleLoadMore}
                hasMore={hasMore}
              />
              <Box className="new-messages-count">Новых сообщений: {(unseenCount > 99 ? "99+" : unseenCount)}</Box>
            </>
          ) : (
            <Typography
              sx={{
                fontSize: "20px",
                textAlign: "center",
                mt: "10px",
                width: "216px",
              }}
            >
              Нет сообщений
            </Typography>
          )}
        </Box>

        {selectedItem ? (
          <EventCard messageId={selectedItem} fetchData={fetchData} setrefetchAfterAccept={setrefetchAfterAccept} />
        ) : (
          <Box className="choose-message">Выберите сообщение для отображения</Box>
        )}
      </DialogContent>
    </Dialog>
  );
};
